import Box from "ds/components/Box";
import FormFieldViewBoolean from "components/FormFields/ViewBoolean";
import FormFieldViewText from "components/FormFields/ViewText";
import { AuditTrailWebhook } from "types/generated";

import Deliveries from "./Deliveries";

const View = (props: AuditTrailWebhook) => {
  const { enabled, endpoint, retryOnFailure, includeRuns, customHeaders = [] } = props;

  return (
    <Box direction="column" padding="x-large" gap="x-large" grow="1">
      <FormFieldViewText label="Endpoint" value={endpoint} noMargin />
      <FormFieldViewText label="Secret" value="••••••••••••••" noTextEllipsis noMargin />
      <FormFieldViewBoolean label="Enabled" value={enabled} noMargin />
      <FormFieldViewBoolean label="Retry on failure" value={retryOnFailure} noMargin />
      <FormFieldViewBoolean label="Include runs" value={includeRuns} noMargin />
      <FormFieldViewText
        label="Headers"
        value={customHeaders.join(", ")}
        emptyPlaceholder="None"
        tooltipInfo="Headers to be sent with each request to the audit trail endpoint. They're encrypted so we're only showing the list of keys here."
        tooltipWidthMode="maxWidthSm"
        noMargin
      />
      <Deliveries />
    </Box>
  );
};

export default View;
